import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import ChristmasRafflePage from "../app/(custom-header)/spring-daily-raffle/page";

const root = createRoot(document.getElementById("christmas-raffle-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <ChristmasRafflePage />
    </StoreProvider>
  </React.StrictMode>
);
